import { createRouter, createWebHistory } from "vue-router";
import TopView from "../views/pages/TopView.vue";
import BoardView from "../views/pages/BoardView.vue";
import CompanyView from "../views/pages/CompanyView.vue";
import CompanyDetailView from "../views/pages/CompanyDetailView.vue";
import PresentationView from "../views/pages/PresentationView.vue";
import LectureView from "../views/pages/LectureView.vue";
import LoginView from "../views/pages/LoginView.vue";
import MyPageView from "../views/pages/MyPageView.vue";
import EnqueteThanksView from "../views/pages/EnqueteThanks.vue";
import ContactThanksView from "../views/pages/ContactThanks.vue";
import EnqueteIndexView from "../views/pages/EnqueteIndex.vue";
import ContactIndexView from "../views/pages/ContactIndex.vue";
import createStoreInstance from "../store/index";
import axiosPlugin from '../plugins/axiosPlugin';
import axiosInstance from "../plugins/axiosPlugin";
//navigationガードのためにstoreの値の初期化を待つ
const storePromise = new Promise((resolve) => {
  resolve(createStoreInstance(axiosPlugin));
});

const routes = [
  {
    path: "/",
    name: "top",
    component: TopView,
    props: true,
    meta: { title: 'トップページ' }
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { title: 'ログインページ' },
  },
  {
    path: "/board",
    name: "board",
    component: BoardView,
    meta: { title: '課題解決掲示板ページ' },
  },
  {
    path: "/company",
    name: "company",
    component: CompanyView,
    meta: { title: '企業一覧ページ' },
  },
  ,
  {
    path: "/companyDetail",
    name: "companyDetail",
    component: CompanyDetailView,
    meta: { requiresAuth: true, title: '企業詳細ページ' },
  },
  ,
  {
    path: "/lecture",
    name: "lecture",
    component: LectureView,
    meta: { title: '基調講演ページ' },
  },
  {
    path: "/presentation",
    name: "presentation",
    component: PresentationView,
    meta: { title: 'プレゼンテーションページ' },
  },
  {
    path: "/myPage",
    name: "myPage",
    component: MyPageView,
    meta: { requiresAuth: true, title: 'マイページ' },
  },
  {
    path: "/enqueteThanks",
    name: "enqueteThanks",
    component: EnqueteThanksView,
    meta: { requiresAuth: true, title: 'アンケート完了ページ' },
  },
  ,
  {
    path: "/contactThanks",
    name: "contactThanks",
    component: ContactThanksView,
    meta: { requiresAuth: true, title: 'お問合せ完了ページ' },
  },
  {
    path: "/enquete",
    name: "enqueteIndex",
    component: EnqueteIndexView,
    meta: { requiresAuth: true, title: 'アンケートページ' },
  },
  ,
  {
    path: "/contact",
    name: "contactIndex",
    component: ContactIndexView,
    meta: { requiresAuth: true, title: 'お問合せページ' },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // trailingSlash オプションを追加
  trailingSlash: true,
  scrollBehavior(to, from, savedPosition) {

    //もし企業ページ関連じゃなかったらスクロールポジションの履歴を消す
    if (to.name != 'company' && to.name != 'companyDetail') {
      sessionStorage.removeItem('companyScrollPosition');
    }

    //もし企業詳細ページから企業一覧へ戻る場合、もとの企業一覧でのスクロール位置へ戻す
    if (to.name == 'company' && from.name == 'companyDetail') {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ top: sessionStorage.getItem('companyScrollPosition') });
        }, 300);
      })
    }

    if (to.fullPath != '/#about') {
      if (savedPosition) {

        //もし企業詳細ページから企業一覧へ戻る場合、もとの企業一覧でのスクロール位置へ戻す
        //if (to.name == 'company' && from.name == 'companyDetail') {
        //  return new Promise((resolve, reject) => {
        //    setTimeout(() => {
        //      resolve(savedPosition);
        //    }, 300);
        //  })
        //}
        //return savedPosition;

      } else {
        return {
          top: 0
        }
      }
    }
  },
});

/**
 * ページ別アクセス数を送信
 * @param {string} pageName 
 */
const sendPageLog = async (pageName) => {
  const sendPageLogNames = [
    'top',
    'board',
    'company',
    'companyDetail',
    'lecture',
    'presentation',
  ];
  if (sendPageLogNames.includes(pageName)) {
    // ここにページ遷移ログを送信する処理を追加
    await axiosInstance.post('/api/log/page', { page_name: pageName });
    console.log(`Page log sent for: ${pageName}`);
  }
}

// ↓ログイン機能廃止に伴うリダイレクト処理
router.beforeEach((to) => {
  const redirectToTopNames = [
    'login',
    'myPage',
    'enqueteIndex',
    'enqueteThanks'
  ];
  if (redirectToTopNames.includes(to.name)) {
    router.push('/');
  } else if (to.name === 'contactIndex' && to.query.company_id) {
    // 企業のお問い合わせページにアクセスした場合、企業詳細ページへリダイレクト
    router.push({ name: 'companyDetail', query: { company_id: to.query.company_id } });
  }
});
// ↑ログイン機能廃止に伴うリダイレクト処理

router.afterEach((to, from) => {
  document.title = to.meta.title ? 'OTEX おかやまテクノロジー展2025 ONLINE 精鋭企業と出会う技術展示商談会 | ' + to.meta.title : 'OTEX おかやまテクノロジー展2025 ONLINE 精鋭企業と出会う技術展示商談会';
  sendPageLog(to.name); // ページ別アクセスログを送信
});

export default router;
